import type { IndexAudit } from "./types";

export const sampleAudit: IndexAudit = {
  requestedUrl: "https://example.com/launch-guide",
  finalUrl: "https://example.com/launch-guide",
  hostname: "example.com",
  checkedAt: "2026-06-14T09:00:00.000Z",
  agent: "Googlebot",
  score: 78,
  scoreLabel: "Close",
  fetch: {
    requestedUrl: "https://example.com/launch-guide",
    finalUrl: "https://example.com/launch-guide",
    hostname: "example.com",
    status: 200,
    ok: true,
    contentType: "text/html; charset=utf-8",
    elapsedMs: 246,
    redirected: false,
    redirectChain: ["https://example.com/launch-guide"],
    error: ""
  },
  robots: {
    found: true,
    status: 200,
    url: "https://example.com/robots.txt",
    agent: "Googlebot",
    allowed: true,
    matchedGroup: "*",
    matchedRule: {
      directive: "allow",
      pattern: "/",
      sourceLine: "allow: /",
      specificity: 1
    },
    sitemapDirectives: ["https://example.com/sitemap.xml"],
    linesChecked: 6,
    error: ""
  },
  metadata: {
    title: "Launch Guide for Static Site Operators",
    description: "A concise launch checklist for static sites covering robots, sitemap, canonical, and preview metadata.",
    canonical: "https://example.com/launch-guide",
    robotsMeta: ["index,follow"],
    googlebotMeta: [],
    xRobotsTag: "",
    ogTitle: "Launch Guide for Static Site Operators",
    ogDescription: "Robots, sitemap, canonical, and preview checks for a clean launch.",
    ogImage: "https://example.com/og/launch-guide.png"
  },
  sitemap: {
    found: true,
    status: 200,
    url: "https://example.com/sitemap.xml",
    type: "urlset",
    urlCount: 42,
    containsTarget: false,
    sampleUrls: [
      "https://example.com/",
      "https://example.com/about",
      "https://example.com/blog",
      "https://example.com/docs",
      "https://example.com/pricing"
    ],
    lastmod: ["2026-06-12", "2026-06-10", "2026-06-02"],
    error: ""
  },
  checks: [
    {
      key: "http",
      group: "HTTP",
      label: "HTTP response",
      level: "pass",
      value: "200",
      detail: "The final URL returned a successful response.",
      points: 20
    },
    {
      key: "robots",
      group: "Crawl",
      label: "Robots access",
      level: "pass",
      value: "Googlebot: allowed",
      detail: "* matched allow: /.",
      points: 20
    },
    {
      key: "index",
      group: "Index",
      label: "Index directives",
      level: "pass",
      value: "index, follow",
      detail: "No public noindex directive was found in meta tags or X-Robots-Tag.",
      points: 20
    },
    {
      key: "canonical",
      group: "Canonical",
      label: "Canonical URL",
      level: "pass",
      value: "https://example.com/launch-guide",
      detail: "The canonical URL aligns with the final URL.",
      points: 15
    },
    {
      key: "sitemap",
      group: "Sitemap",
      label: "Sitemap discovery",
      level: "warn",
      value: "42 URL entries",
      detail: "A sitemap was found, but the tested URL was not in the readable sample.",
      points: 9
    },
    {
      key: "preview",
      group: "Preview",
      label: "Page and social metadata",
      level: "pass",
      value: "title / description / OG image",
      detail: "Title, description, and OpenGraph image are present.",
      points: 10
    }
  ],
  issues: [
    {
      level: "warn",
      group: "Sitemap",
      title: "Sitemap discovery",
      detail: "A sitemap was found, but the tested URL was not in the readable sample."
    }
  ],
  generated: {
    robots: "User-agent: *\nAllow: /\n\nSitemap: https://example.com/sitemap.xml",
    sitemap:
      "<url>\n  <loc>https://example.com/launch-guide</loc>\n  <lastmod>2026-06-14</lastmod>\n  <changefreq>weekly</changefreq>\n  <priority>0.8</priority>\n</url>",
    meta:
      '<title>Launch Guide for Static Site Operators</title>\n<meta name="description" content="A concise launch checklist for static sites covering robots, sitemap, canonical, and preview metadata.">\n<meta name="robots" content="index,follow">\n<link rel="canonical" href="https://example.com/launch-guide">\n<meta property="og:title" content="Launch Guide for Static Site Operators">\n<meta property="og:description" content="Robots, sitemap, canonical, and preview checks for a clean launch.">',
    markdown:
      "# IndexSeal report for example.com\n\n- Checked URL: https://example.com/launch-guide\n- Score: 78/100\n- Robots result: allowed by allow: /\n- Sitemap: 42 entries at https://example.com/sitemap.xml\n\n## Checks\n- PASS HTTP: HTTP response - 200\n- PASS Crawl: Robots access - Googlebot: allowed\n- PASS Index: Index directives - index, follow\n- PASS Canonical: Canonical URL - https://example.com/launch-guide\n- WARN Sitemap: Sitemap discovery - 42 URL entries\n- PASS Preview: Page and social metadata - title / description / OG image"
  },
  summary: {
    passes: 5,
    warnings: 1,
    failures: 0,
    informational: 0
  }
};
